<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-row class="mx-0 mb-2">
            <h2>{{ $t('server.api.backoffice.register.title') }}</h2>
        </v-row>
        <v-row class="mb-3">
            <v-col cols="12" md="6">
                <h4>Benutzerdaten</h4>
                <v-col class="d-inline-flex align-items-center">
                    <v-label class="mr-4">{{$t('global.form.username')}}</v-label>
                    <v-text-field  variant="outlined" density="compact"
                        :hide-details="true">
                    </v-text-field>
                </v-col>
                <v-col class="d-inline-flex align-items-center">
                    <v-label class="mr-4">{{$t('global.form.email')}}</v-label>
                    <v-text-field  variant="outlined" density="compact"
                        :hide-details="true">
                    </v-text-field>
                </v-col>
            </v-col>
            <v-col cols="12" md="6">
                <h4>Shopdaten</h4>
                <v-col class="d-inline-flex align-items-center">
                    <v-label class="mr-4">{{$t('global.form.name')}}</v-label>
                    <v-text-field  variant="outlined" density="compact"
                        :hide-details="true">
                    </v-text-field>
                </v-col>
                <v-col class="d-inline-flex align-items-center">
                    <v-label class="mr-4">{{$t('global.form.city')}}</v-label>
                    <v-text-field  variant="outlined" density="compact"
                        :hide-details="true">
                    </v-text-field>
                </v-col>
            </v-col>
            <v-col cols="12" class="justify-end d-flex">
                <v-btn class="px-3 py-1 text-right" variant="flat" rounded="xl" size="large"
                    color="primary">{{ $t('entity.action.register') }}</v-btn>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import { ref, inject, getCurrentInstance, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

export default {
    components: {
        
    },
    setup() {

        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const { t, locale } = useI18n();


        return {
            selectedLanguage,
        };
    },

    watch: {

    },

    data: () => ({
        
    }),

    computed: {
    },

    mounted() {
    },

    methods: {
        
    },
}
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 900px;
    margin-top: 40px;
}


</style>

<style>

</style>

<style></style>